import { useMemo } from "react"

import { usePhotoQuery } from "../usePhotoQuery"

import { imageCollectionQueryKeys } from "./queryKeys"

export function useImageCollection(imageCollection, queryParameters, config = {}) {
    const parameters = {
        ...queryParameters,
        collection: imageCollection?.uuid,
        as_geojson: true,
    }
    const { enabled = true } = config
    const queryKey = imageCollectionQueryKeys.list(parameters)
    const url = "photos/"

    const { data, isLoading, isError } = usePhotoQuery(
        url,
        queryKey,
        parameters,
        {
            ...config,
            enabled: !!imageCollection?.uuid && enabled,
        },
    )

    const sanitizedData = useMemo(() => {
        if (data) {
            return {
                ...data,
                features: data.features.filter(feature => {
                    const coordinates = feature?.geometry?.coordinates
                    return typeof coordinates?.[0] === "number" && typeof coordinates?.[1] === "number"
                }),
            }
        }
        return data
    }, [data])

    return ({ data: sanitizedData, isLoading, isError })
}